import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MxCrudService {

  onClosed = new Subject<void>();

  constructor() { }
}
